module.exports = __webpack_public_path__ + "img/打赏作者@2x.6da58f68.png";